import { useTranslation } from 'i18n';
import { Alert, Typography } from 'ui';

import { guideImages } from '../../data';
import { GuideImage } from '../GuideImage/GuideImage';

export const PartThree = ({ obfuscateAi }: { obfuscateAi: boolean }) => {
  const { t } = useTranslation('features');

  return (
    <>
      <GuideImage
        src={guideImages.reviewDelete}
        alt={t('backlog.helpGuides.aiLoose.partThree.imageAlt')}
        height="fixed"
      />
      <Typography>
        <Typography component="span" fontWeight="bold">
          {t('backlog.helpGuides.aiLoose.partThree.boldIntro')}&nbsp;
        </Typography>
        {t('backlog.helpGuides.aiLoose.partThree.trailingText')}
      </Typography>
      {obfuscateAi ? null : (
        <Alert severity="warning" sx={{ textAlign: 'start' }}>
          <Typography>
            {t('backlog.helpGuides.aiLoose.partThree.warningPrefix')}&nbsp;
            <Typography component="span" fontWeight="bold">
              {t('backlog.helpGuides.aiLoose.partThree.warningBold')}&nbsp;
            </Typography>
            {t('backlog.helpGuides.aiLoose.partThree.warningSuffix')}
          </Typography>
        </Alert>
      )}
    </>
  );
};
